<script setup lang="ts">
// Discussion-group QR dialog (production assets/js/app.js openContactQr; assets/css/nav-availability.css).
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import { closeContact } from '../stores/overlays'

const QR = '/assets/brand/wechat-discussion.jpg'
const shown = ref(false)

function onKeydown(event: KeyboardEvent) { if (event.key === 'Escape') closeContact() }
onMounted(() => {
  document.body.classList.add('qr-modal-open')
  window.addEventListener('keydown', onKeydown)
  void nextTick(() => requestAnimationFrame(() => { shown.value = true }))
})
onBeforeUnmount(() => {
  document.body.classList.remove('qr-modal-open')
  window.removeEventListener('keydown', onKeydown)
})
</script>

<template>
  <div id="contactQrModal" class="contact-qr-modal" :class="{ show: shown }" @click.self="closeContact">
    <div class="contact-qr-dialog" role="dialog" aria-modal="true" aria-label="微信讨论群二维码">
      <button class="contact-qr-close" type="button" aria-label="关闭二维码" @click="closeContact">×</button>
      <span class="contact-qr-kicker">SCAN TO JOIN</span>
      <h2>微信讨论群</h2>
      <p>放大后即可扫码，也可以保存二维码图片</p>
      <img class="contact-qr-large" :src="QR" alt="微信讨论群二维码">
      <div class="contact-qr-actions">
        <a class="btn btn-p" :href="QR" download="导游学霸-微信讨论群二维码.jpg">保存二维码</a>
        <button class="btn btn-g" type="button" @click="closeContact">关闭</button>
      </div>
    </div>
  </div>
</template>
